import { ApplicationConfigProvider as env } from './environment'

export const ApplicationConfigProvider = env

export const ProjectName = 'Dida Analysis';

export const primaryColor = '#5B8FF9';

export const textColor = 'rgba(0, 0, 0, .65)';

export const defaultLocale = 'en-US';

export const userToken = 'as_token_by_user_id';

export const ssoAnthConfig = {
  authority: ApplicationConfigProvider.current.ssoUrl,
  scope: 'openid profile Analysis.API offline_access Whale.API',
  client_id: 'Analysis.API',
  redirect_uri: ApplicationConfigProvider.current.baseUrl + '/Account/LoginCallback',
  silent_redirect_uri: ApplicationConfigProvider.current.baseUrl + '/Account/SilentRenew'
}